import { Classes } from '@blueprintjs/core'
import React, { useState } from 'react'
import {
    Dialog, FormInput, DeleteButton
} from '../../../Elements'


const DeleteJobDialog = ({deleteDialogIsOpen, setDeleteDialogIsOpen, onDelete}) => {
    const [userResponse, setUserResponse] = useState('')

    return <Dialog
        icon='trash'
        title='Delete Job?'
        isOpen={deleteDialogIsOpen}
        canOutsideClickClose={true}
        canEscapeKeyClose={true}
        isCloseButtonShown={true}
        onClose={() => setDeleteDialogIsOpen(false)}
    >
        <div className={Classes.DIALOG_BODY}>
            <p>Are you sure you want to delete this job? It cannot be reversed</p>
            <p><strong>Type 'DELETE JOB' to delete this Job</strong></p>
            <FormInput 
                value={userResponse}
                onChange={(e) => setUserResponse(e.target.value)}
            />
            <DeleteButton 
                disabled={userResponse !== 'DELETE JOB'}
            
            onClick={onDelete} />

        </div>
    </Dialog>
}

export default DeleteJobDialog